import React, { Component } from "react";



import surgaricon1 from "../images/section2/item1.svg"
import surgaricon2 from "../images/section2/item2.svg"
import surgaricon3 from "../images/section2/item3.svg"
import surgaricon4 from "../images/section2/item4.svg"


import diabeteskillicon1 from "../images/section1/item1.svg"
import diabeteskillicon2 from "../images/section1/item2.svg"
import diabeteskillicon3 from "../images/section1/item3.svg"
import diabeteskillicon4 from "../images/section1/item4.svg"


import surgaricon11 from "../images/section3/item1.svg"
import surgaricon22 from "../images/section3/item2.svg"
import surgaricon33 from "../images/section3/item3.svg"
import surgaricon44 from "../images/section3/item4.svg"


class HorizontalAcc extends  Component{
componentDidMount(){
   
}
render(){
return (
   <section className="reversal-technology-sec">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="reversal-technology-inner wow  fadeInUp" data-wow-duration="1s" data-wow-delay=".1s">
                                <div className="gallery-wrap">
                                    <div className="technology-item technology-item-1 active ">
                                        <h2>You deserve a diabetes free life!</h2>
                                        <div className="firstSlideMainDiv technology-nner"> 
                                            <h1>You deserve a diabetes free life!</h1>
                                            <ul>
                                                <li><img src={diabeteskillicon1} alt="" className="lazyload"/><p>Diabetes kills 4320* people everyday</p></li>
                                                <li><img src={diabeteskillicon2} alt="" className="lazyload"/><p>Increases chances of heart diseases, cancer &amp; other chronic diseases</p></li>
                                                <li><img src={diabeteskillicon3} alt="" className="lazyload"/><p>Damages your eyes, liver, kidney, brain &amp; legs</p></li>
                                                <li><img src={diabeteskillicon4} alt="" className="lazyload"/><p>Energy &amp; productivity loss upto 44%</p></li>
                                               
                                                
                                            </ul> 
                                        </div>
                                    </div>
                                    <div className="technology-item technology-item-2">
                                        <h2>Be 100% Happy &amp; Healthy with diabetes reversal</h2>
                                        <div className="technology-nner"> 
                                            <h1>Be 100% Happy &amp; Healthy with diabetes reversal</h1>
                                            <ul>
                                                <li><img src={surgaricon1} alt="" className="lazyload"/><p>Normalise your sugar levels </p></li>
                                                <li><img src={surgaricon2} alt="" className="lazyload"/><p>Stop all medicines  &amp; insulin</p></li>
                                                <li><img src={surgaricon3} alt="" className="lazyload"/><p>Improved your mood &amp; energy</p></li>
                                                <li><img src={surgaricon4} alt="" className="lazyload"/><p>Become healthy &amp; fit</p></li>
                                                {/* <li><img src={surgaricon5} alt="" className="lazyload"/><p>Get a permanent solution for diabetes!</p> </li> */}
                                            </ul> 
                                        </div>
                                    </div>
                                    <div className="technology-item technology-item-3">
                                        <h2>Twin reverses your diabetes with the latest technology!</h2>
                                        <div className="technology-nner"> 
                                            <h1>Twin reverses your diabetes with the latest technology!</h1>
                                            <ul>
                                                <li><img  src={surgaricon11} alt="" className="lazyload"/><p>Treating the root cause of ‘Damaged Metabolism’</p></li>
                                                <li><img  src={surgaricon22} alt="" className="lazyload"/><p>Personalised Treatment for you</p></li>
                                                <li><img  src={surgaricon33} alt="" className="lazyload"/><p>Powered by Precision Technology</p></li>
                                                <li><img  src={surgaricon44} alt="" className="lazyload"/><p>Offered by Leading Doctors &amp; Coaches</p></li>
                                                
                                                
                                            </ul> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
)
}
}
export default HorizontalAcc